import { calcResize } from 'components/Layout/styles';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

export const SHeader = styled.div`
  height: ${props => (props.adCampaign ? '63px' : '200px')};
  position: relative;
  border-bottom: ${props => (props.adCampaign ? '4px solid #f7a619' : null)};

  &:before {
    content: '';
    position: absolute;
    background: ${props =>
      props.adCampaign ? '#335aa7' : "url('/wave_background.svg') 0 0 repeat"};
    transform: rotate(180deg);
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;

export const SCol = styled(Col)`
  align-self: center;
`;

export const SRow = styled(Row)`
  min-height: 200px;
`;

export const STitle = styled.h3`
  max-width: 1000px;
  word-wrap: break-word;
  color: #ffffff;
  font-size: ${calcResize(24, 30)};
`;
export const STitleH2 = styled.h2`
  max-width: 1000px;
  word-wrap: break-word;
  color: #ffffff;
  font-size: ${calcResize(24, 30)};
`;

export const STitleH1 = styled.h1`
  max-width: 1000px;
  word-wrap: break-word;
  color: #ffffff;
  font-size: ${calcResize(24, 30)};
`;
